import React from "react";
import { DateFormatRenderer } from "components/common/ag-grid";
import { Link } from "react-router-dom";
import SoftBadge from 'components/common/SoftBadge';

export const columnDefs = [
  { 
    headerName: 'ID#',
    field: 'id',
    minWidth: 50,
    width: 50,
    cellRenderer: (params) => {
      return  <Link to={`/request/terminal-accounts/${params.data.id}`} target="_blank">{params.value}</Link>
    },
  },
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 120,
    width: 140,
    flex: 0,
    pinned: 'left',
    cellRenderer: (params) => {
      return  <Link to={`/request/terminal-accounts/${params.data.id}`} target="_blank">{params.value}</Link>
    },
  },
  { 
    headerName: 'Email',
    field: 'email',
    minWidth: 160
  },
  { 
    headerName: 'Title',
    field: 'title',
    minWidth: 130,
  },
  { 
    headerName: 'Terminal date',
    field: 'terminal_date',
    minWidth: 120,
    cellRenderer: DateFormatRenderer
  },
  { 
    headerName: 'Department',
    field: 'department.name',
    minWidth: 150
  },
  { 
    headerName: 'Site',
    field: 'site.name',
    minWidth: 140
  },
 
  { 
    headerName: 'Status',
    field: 'status',
    minWidth: 120,
    cellRenderer: params => {
      const value = params.value;
      return <SoftBadge bg={`${value === "Closed" ? "success" : "danger"}`}>{value}</SoftBadge>;
    }
  },
  { 
    headerName: 'Closed by',
    field: 'closed_by',
    minWidth: 110
  },
  { 
    headerName: 'Closed date',
    field: 'closed_date',
    minWidth: 120,
    cellRenderer: DateFormatRenderer
  },
  { 
    headerName: 'Submited by',
    field: 'created_by',
    minWidth: 120
  },
  { 
    headerName: 'Submited date',
    field: 'created_date',
    minWidth: 150
  }
];